export const PauseIcon = ({ className }) => {
  return (
    <svg className={className} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="4" height="12" fill="currentColor" />
      <rect x="8" width="4" height="12" fill="currentColor" />
    </svg>

  )
}